/**
 * @file
 * Media block script.
 */

/**
 * For Media block - video variants.
 *
 * Pinterest Youtube Video with custom poster image JS.
 */
(function ($, Drupal) {
  'use strict';

  Drupal.behaviors.pinYouTubePlayer = {
    attach: function (context, settings) {
      var $video = $('.video--youtube', context);

      // trigger the video player, hide the poster
      $video.each(function () {
        var $playTrigger = $(this).find('.js-play-trigger');
        if ($playTrigger.length > 0) {
          var $videoPlayer = $playTrigger.next('.video-player');
          if ($videoPlayer.length > 0) {
            var $videoIframe = $videoPlayer.find('iframe');
            if ($videoIframe.length > 0 && $videoIframe.attr('src')) {
              $playTrigger.addClass('js-play-trigger--with-video');

              $playTrigger.on('click', function (e) {
                var $trigger = $(this);
                e.preventDefault();
                var $player = $playTrigger.next('.video-player');
                var $iframe = $player.find('iframe');
                var src = $iframe.attr('src');
                if (src) {
                  src = src.replace('autoplay=0', 'autoplay=1');
                  $iframe.attr('src', src);
                  $trigger.hide();
                  $player.show();
                }
              });
            }
          }
        }
      });

    }
  };

})(jQuery, Drupal);
